import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'Workforce',
  name: 'BusinessUserHourManagement',
  component: EmptyRouterAlive,
  meta: {
    title: '用工管理',
  },
  children: [
    {
      path: 'Hour',
      name: 'BusinessUserTimeManagement',
      component: EmptyRouter,
      redirect: 'hour/index',
      meta: { title: '工时管理', isCache: true },
      children: [
        {
          path: 'index',
          name: 'BusinessUserTimeManagement',
          component: () => import('@/views/center-business/user/hour'),
          meta: { title: '工时管理', isCache: true },
        },
      ],
    },
  ],
};
